import HomeIcon from '@material-ui/icons/Home'
import ProfileIcon from '@material-ui/icons/AccountBox'
import CohortIcon from '@material-ui/icons/Contacts'
import TeamIcon from '@material-ui/icons/GroupWork'
import ResourcesIcon from '@material-ui/icons/Folder'
import ForumIcon from '@material-ui/icons/Forum'
import EventsIcon from '@material-ui/icons/Event'
import PartnershipsIcon from '@material-ui/icons/Loyalty'
import AdvisorsIcon from '@material-ui/icons/SupervisedUserCircle'
import SettingsIcon from '@material-ui/icons/Settings'
import AlaCohortIcon from '@material-ui/icons/Group'
import FlashOnIcon from '@material-ui/icons/FlashOn'

import { hubModes } from 'contexts/AppContext'

export {
  HomeIcon,
  ProfileIcon,
  CohortIcon,
  TeamIcon,
  ResourcesIcon,
  ForumIcon,
  EventsIcon,
  PartnershipsIcon,
  AdvisorsIcon,
  SettingsIcon,
  AlaCohortIcon,
}

export enum routes {
  adminAuth = '/adminAuth',
  setLocation = '/setLocation',
  forgotPassword = '/forgotPassword',
  resetPassword = '/resetPassword',
  googleAuth = '/googleAuth',
  authLink = '/authLink',
  signIn = '/signIn',
  discourse = '/discourse',

  home = '/home',
  profile = '/profile',
  cohort = '/cohort',
  course = '/course',
  library = '/library',
  redirect = '/redirect',

  settings = '/settings',
  signOut = '/signOut',
}

export type Route = {
  label: string
  showLocationInLabel?: boolean
  route: string
  Icon: typeof HomeIcon
  restrictions: string[]
  children?: {
    label: string
    route: string
    restrictions: string[]
  }[]
}

const home = {
  label: 'Home',
  route: routes.home,
  Icon: HomeIcon,
  restrictions: [],
}
const profile = {
  label: 'Profile',
  route: routes.profile,
  Icon: ProfileIcon,
  restrictions: [],
}
const cohort = {
  label: 'Cohort',
  route: routes.cohort,
  Icon: CohortIcon,
  restrictions: [],
}
const course = {
  label: 'Live Session',
  route: routes.course,
  Icon: EventsIcon,
  restrictions: [],
}
const library = {
  label: 'Antler Library',
  route: routes.library,
  Icon: ResourcesIcon,
  restrictions: [],
}
const credential = {
  label: 'Course Credential',
  route: 'https://antlerlaunchacademy.carrd.co/',
  externalRoute: true,
  Icon: PartnershipsIcon,
  restrictions: [],
}

const ideatorsTrack = {
  label: 'Ideators Track',
  route: 'https://launchacademy.antler.co/premium-tracks/ideators',
  externalRoute: true,
  Icon: FlashOnIcon,
  restrictions: [],
}

export const navItems: Record<string, Route[]> = {
  [hubModes.internal]: [
    home,
    profile,
    cohort,
    course,
    library,
    credential,
    ideatorsTrack,
  ],
  [hubModes.student]: [
    home,
    profile,
    cohort,
    course,
    library,
    credential,
    ideatorsTrack,
  ],
  [hubModes.studentViewOnly]: [
    home,
    profile,
    course,
    library,
    credential,
    ideatorsTrack,
  ],
}
